document.addEventListener('DOMContentLoaded', function () {
    const customColorInputs = document.querySelectorAll('input[name^="properties[color_"]:not([name="options[Color]"]):not([name="options[color]"])');
    const customChoiceInputs = document.querySelectorAll('input[name^="properties[choice_"]');
    const priceOptionInputs = document.querySelectorAll('input[name="properties[price_option]"]');

    // Handle multiselect functionality
    function handleMultiselect(element) {
        const isMultiselect = element.hasAttribute('data-multiselect');
        if (!isMultiselect) return;

        const maxSelections = parseInt(element.getAttribute('data-max-selections')) || 1;
        const selectedValueSpan = element.closest('.product-form__input').querySelector('[data-selected-value]');

        if (element.tagName === 'SELECT') {
            // Previously handled native <select multiple>. Replaced by custom component; skip.
            return;
        } else {
            // Handle multiselect checkboxes (fieldset)
            const checkboxes = element.querySelectorAll('input[type="checkbox"]');

            function updateSelectionCount() {
                const checkedBoxes = element.querySelectorAll('input[type="checkbox"]:checked');
                const currentCount = checkedBoxes.length;

                // Update selected value display with comma-separated values
                if (selectedValueSpan) {
                    const selectedValues = Array.from(checkedBoxes).map(cb => cb.value);
                    selectedValueSpan.textContent = selectedValues.length > 0 ? selectedValues.join(', ') : '';
                }

                // Disable/enable checkboxes based on limit
                checkboxes.forEach(checkbox => {
                    if (!checkbox.checked && currentCount >= maxSelections) {
                        checkbox.disabled = true;
                        checkbox.closest('label')?.classList.add('disabled');
                    } else {
                        checkbox.disabled = false;
                        checkbox.closest('label')?.classList.remove('disabled');
                    }
                });
            }

            checkboxes.forEach(checkbox => {
                checkbox.addEventListener('change', function (e) {
                    e.stopPropagation();
                    debugger;
                    console.log("s 1");

                    updateSelectionCount();

                    const checkedBoxes = element.querySelectorAll('input[type="checkbox"]:checked');
                    const selectedValues = Array.from(checkedBoxes).map(cb => cb.value);
                    console.log('Custom multiselect color selected:', this.name, '=', selectedValues);

                    const targetElement = document.querySelector(`[title="${this.value}"][data-section-name="${this.name}"]`);
                    if (targetElement) {
                        const elementSwatchType = targetElement.classList.contains('swatch-input__label--square') ? 'square' : 'circle';
                        const isSelected = targetElement.getAttribute('data-is-selected');
                        // Only add class if it wasn't already selected
                        if (isSelected !== 'true') {
                            targetElement.classList.add(`wd-selected-${elementSwatchType}-color`);
                            targetElement.setAttribute('data-is-selected', 'true');
                        } else {
                            targetElement.classList.remove(`wd-selected-${elementSwatchType}-color`);
                            targetElement.setAttribute('data-is-selected', 'false');
                        }
                    }
                });
            });

            // Initialize count
            updateSelectionCount();
        }
    }

    // Initialize multiselect for all custom color fieldsets and dropdowns
    document.querySelectorAll('fieldset[data-multiselect], select[data-multiselect]').forEach(handleMultiselect);

    // Set initial selected value display for custom color groups on first load (single select)
    customColorInputs.forEach(input => {
        if (input.type === 'radio' && input.checked) {
            debugger;
            const fieldset = input.closest('fieldset, .product-form__input');
            const selectedValueSpan = fieldset ? fieldset.querySelector('[data-selected-value]') : null;
            if (selectedValueSpan && !selectedValueSpan.textContent.trim()) {
                selectedValueSpan.textContent = input.value;
            }
        }
    });

    // Handle single select radio buttons
    customColorInputs.forEach(input => {
        if (input.type === 'radio') {
            input.addEventListener('change', function (e) {
                console.log("press", e);

                // Prevent the event from bubbling up to variant-selects
                e.stopPropagation();
                debugger;
                console.log("s 2");

                // Update the selected value display for this color group
                const fieldset = this.closest('fieldset, .product-form__input');
                const selectedValueSpan = fieldset ? fieldset.querySelector('[data-selected-value]') : null;

                if (selectedValueSpan && this.checked) {
                    selectedValueSpan.textContent = this.value;
                }

                // Reset all previously selected labels for this section
                const previouslySelectedLabels = document.querySelectorAll(`label[data-section-name="${this.name}"][data-is-selected="true"]`);
                previouslySelectedLabels.forEach(label => {
                    label.classList.remove('wd-selected-square-color');
                    label.setAttribute('data-is-selected', 'false');
                });

                // Find element where title = this.value & data-section-name = this.name
                const targetElement = document.querySelector(`[title="${this.value}"][data-section-name="${this.name}"]`);
                if (targetElement) {
                    const isSelected = targetElement.getAttribute('data-is-selected');
                    // Only add class if it wasn't already selected (don't toggle if same item pressed)
                    if (isSelected !== 'true') {
                        targetElement.classList.add('wd-selected-square-color');
                        targetElement.setAttribute('data-is-selected', 'true');
                    }
                }

                // Custom logic for color selection can go here
                console.log('Custom color selected:', this.name, '=', this.value);
            });
        }
    });

    // Handle choice radios (button style)
    customChoiceInputs.forEach(input => {
        if (input.type === 'radio') {
            input.addEventListener('change', function (e) {
                e.stopPropagation();
                console.log("s 3");
                debugger;

                const fieldset = this.closest('fieldset, .product-form__input');
                const selectedValueSpan = fieldset ? fieldset.querySelector('[data-selected-value]') : null;
                if (selectedValueSpan && this.checked) {
                    selectedValueSpan.textContent = this.value;
                }
                console.log('Custom choice selected:', this.name, '=', this.value);
            });
        }
    });

    // Initialize selected value display for choice groups
    customChoiceInputs.forEach(input => {
        if (input.type === 'radio' && input.checked) {
            const fieldset = input.closest('fieldset, .product-form__input');
            const selectedValueSpan = fieldset ? fieldset.querySelector('[data-selected-value]') : null;
            if (selectedValueSpan && !selectedValueSpan.textContent.trim()) {
                selectedValueSpan.textContent = input.value;
            }
        }
    });

    // Handle price option radios
    priceOptionInputs.forEach(inp => {
        if (inp.type === 'radio') {
            inp.addEventListener('change', e => {
                e.stopPropagation();
                debugger;

                console.log("s 4");

                const fieldset = inp.closest('fieldset, .product-form__input');
                const selectedValueSpan = fieldset ? fieldset.querySelector('[data-selected-value]') : null;
                if (selectedValueSpan && inp.checked) {
                    selectedValueSpan.textContent = inp.value;
                }
                console.log('Price option selected:', inp.name, '=', inp.value);
            });
        }
    });
    // Initialize selected value for price options
    priceOptionInputs.forEach(inp => {
        if (inp.type === 'radio' && inp.checked) {
            const fieldset = inp.closest('fieldset, .product-form__input');
            const selectedValueSpan = fieldset ? fieldset.querySelector('[data-selected-value]') : null;
            if (selectedValueSpan && !selectedValueSpan.textContent.trim()) {
                selectedValueSpan.textContent = inp.value;
            }
        }
    });

    // Handle custom color dropdown selections with swatch updates
    const customColorDropdowns = document.querySelectorAll('select[data-custom-color-dropdown]');

    customColorDropdowns.forEach(select => {
        // Skip if this dropdown is already handled by multiselect
        if (select.hasAttribute('data-multiselect')) return;

        select.addEventListener('change', function (e) {
            // Prevent the event from bubbling up to variant-selects
            e.stopPropagation();

            debugger;
            console.log("s 5");
            const container = this.closest('.product-form__input--dropdown');
            const dropdownSwatch = container ? container.querySelector('.dropdown-swatch .swatch') : null;
            const selectedOption = this.options[this.selectedIndex];
            const selectedValueSpan = container ? container.querySelector('[data-selected-value]') : null;

            // Update selected value display for single select
            if (selectedValueSpan && !this.hasAttribute('multiple')) {
                selectedValueSpan.textContent = this.value;
            }

            if (dropdownSwatch && selectedOption) {
                const swatchValue = selectedOption.getAttribute('data-option-swatch-value');

                if (swatchValue) {
                    // Update the swatch display
                    dropdownSwatch.className = 'swatch'; // Reset classes

                    if (swatchValue.includes('url(') || swatchValue.includes('#')) {
                        dropdownSwatch.style.setProperty('--swatch--background', swatchValue);
                        dropdownSwatch.style.removeProperty('background-color');
                    } else {
                        dropdownSwatch.style.setProperty('background-color', swatchValue);
                        dropdownSwatch.style.removeProperty('--swatch--background');
                        dropdownSwatch.classList.add('swatch--unavailable');
                    }
                }
            }

            // Custom logic for color selection can go here
            console.log('Custom color dropdown selected:', this.name, '=', this.value);
        });
    });

    // Custom multi-dropdown component handling
    const multiDropdowns = document.querySelectorAll('.multi-dropdown[data-multiselect]');
    multiDropdowns.forEach(dd => {
        const toggle = dd.querySelector('.multi-dropdown__toggle');
        const panel = dd.querySelector('.multi-dropdown__panel');
        const closeBtn = dd.querySelector('[data-close]');
        const checkboxes = dd.querySelectorAll('input[type="checkbox"][data-multi-option]');
        const selectedValueSpan = dd.querySelector('[data-selected-value]');
        const maxSelections = parseInt(dd.getAttribute('data-max-selections')) || 1;
        const toggleText = dd.querySelector('[data-toggle-text]');

        function updateState() {
            console.log("s 6");
            const selected = Array.from(checkboxes).filter(cb => cb.checked).map(cb => cb.value);
            const joined = selected.join(', ');
            if (selectedValueSpan) {
                selectedValueSpan.textContent = joined || '';
            }
            if (toggleText) {
                toggleText.textContent = joined || (toggleText.dataset.placeholder || 'Select');
                toggleText.setAttribute('title', joined);
                toggleText.classList.toggle('is-active', !!joined);
            }
            // Enforce limit
            const count = selected.length;
            checkboxes.forEach(cb => {
                if (!cb.checked && count >= maxSelections) {
                    cb.disabled = true;
                    cb.closest('label')?.classList.add('disabled');
                } else {
                    cb.disabled = false;
                    cb.closest('label')?.classList.remove('disabled');
                }
            });
        }

        function openPanel() {
            panel.hidden = false;
            toggle.setAttribute('aria-expanded', 'true');
            panel.classList.add('is-open');
            dd.classList.add('is-open');
            // focus first enabled checkbox label for accessibility
            const first = Array.from(checkboxes).find(cb => !cb.disabled);
            if (first) {
                first.focus({ preventScroll: true });
            }
            toggle.classList.add('force-focus');
        }
        function closePanel() {
            panel.hidden = true;
            toggle.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-open');
            dd.classList.remove('is-open');
            toggle.classList.remove('force-focus');
        }

        toggle.addEventListener('click', e => {
            e.preventDefault();
            panel.hidden ? openPanel() : closePanel();
        });
        closeBtn?.addEventListener('click', e => {
            e.preventDefault();
            closePanel();
        });

        // Close on outside click
        document.addEventListener('click', e => {
            if (!dd.contains(e.target) && !panel.hidden) {
                closePanel();
            }
        });
        // Esc key
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' && !panel.hidden) {
                closePanel();
            }
        });

        checkboxes.forEach(cb => {
            cb.addEventListener('change', () => {
                updateState();
                console.log('Custom multi-dropdown selection', cb.name, cb.value);
            });
        });

        // Initialize placeholder
        if (toggleText && !toggleText.dataset.placeholder) {
            toggleText.dataset.placeholder = toggleText.textContent.trim();
        }
        updateState();
    });

    // === Inject custom color selections into line item properties on form submit ===
    const productForm = document.getElementById('{{ product_form_id }}');
    if (productForm) {
        productForm.addEventListener('submit', function (e) {
            // Remove previously injected hidden inputs to avoid duplicates on AJAX retries
            productForm.querySelectorAll('.js-custom-color-prop').forEach(n => n.remove());

            const colorGroupNodeList = document.querySelectorAll('[data-color-label][data-color-loop]');
            const colorGroups = Array.from(colorGroupNodeList).map((el, idx) => {
                const posAttr = el.getAttribute('data-color-position');
                const pos = posAttr && posAttr.trim() !== '' && !isNaN(parseInt(posAttr, 10)) ? parseInt(posAttr, 10) : null;
                return { el, originalIndex: idx, position: pos };
            });

            // Sort: positioned (ascending) first, then unpositioned preserving original order
            colorGroups.sort((a, b) => {
                if (a.position !== null && b.position !== null) return a.position - b.position;
                if (a.position !== null) return -1;
                if (b.position !== null) return 1;
                return a.originalIndex - b.originalIndex; // stable fallback
            });

            const labelCounts = {};

            function titleCase(str) {
                return str.split(/\s+/).filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
            }

            colorGroups.forEach(({ el }) => {
                const labelRaw = el.getAttribute('data-color-label') || 'Color';
                const loopIndex = el.getAttribute('data-color-loop');
                // Base normalization: trim, remove trailing colon, title case
                let baseLabel = labelRaw.trim().replace(/:\s*$/, '');
                if (baseLabel === '') baseLabel = 'Color';
                baseLabel = titleCase(baseLabel);

                // Collect selected values
                let values = [];
                if (el.matches('fieldset')) {
                    const inputs = el.querySelectorAll('input[type="checkbox"], input[type="radio"]');
                    inputs.forEach(inp => { if (inp.checked) values.push(inp.value); });
                } else if (el.classList.contains('multi-dropdown')) {
                    const checks = el.querySelectorAll('input[type="checkbox"][data-multi-option]');
                    checks.forEach(cb => { if (cb.checked) values.push(cb.value); });
                } else { // single dropdown div wrapper
                    const sel = el.querySelector('select');
                    if (sel && sel.value) values.push(sel.value);
                }

                if (values.length === 0) return; // skip empty

                if (labelCounts[baseLabel] == null) {
                    labelCounts[baseLabel] = 0;
                } else {
                    labelCounts[baseLabel] += 1;
                }
                const count = labelCounts[baseLabel];
                let finalLabel = baseLabel;
                if (count > 0) {
                    finalLabel = baseLabel + ' ' + loopIndex; // append loop index for uniqueness
                }

                const hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.className = 'js-custom-color-prop';
                hidden.name = `properties[${finalLabel}]`;
                hidden.value = values.join(', ');
                productForm.appendChild(hidden);
            });

            // Choice groups properties (ordered by position)
            const choiceGroupNodeList = document.querySelectorAll('[data-choice-label][data-choice-loop]');
            const choiceGroups = Array.from(choiceGroupNodeList).map((el, idx) => {
                const posAttr = el.getAttribute('data-choice-position');
                const pos = posAttr && posAttr.trim() !== '' && !isNaN(parseInt(posAttr, 10)) ? parseInt(posAttr, 10) : null;
                return { el, originalIndex: idx, position: pos };
            });
            choiceGroups.sort((a, b) => {
                if (a.position !== null && b.position !== null) return a.position - b.position;
                if (a.position !== null) return -1;
                if (b.position !== null) return 1;
                return a.originalIndex - b.originalIndex;
            });

            const choiceLabelCounts = {};
            choiceGroups.forEach(({ el }) => {
                const labelRaw = el.getAttribute('data-choice-label') || 'Choice';
                const loopIndex = el.getAttribute('data-choice-loop');
                let baseLabel = labelRaw.trim().replace(/:\s*$/, '');
                if (baseLabel === '') baseLabel = 'Choice';
                baseLabel = titleCase(baseLabel);

                // Collect selected value
                let selectedVal = '';
                const radioChecked = el.querySelector('input[type="radio"]:checked');
                if (radioChecked) {
                    selectedVal = radioChecked.value;
                } else {
                    const sel = el.querySelector('select');
                    if (sel && sel.value) selectedVal = sel.value;
                }
                if (selectedVal === '') return;

                if (choiceLabelCounts[baseLabel] == null) {
                    choiceLabelCounts[baseLabel] = 0;
                } else {
                    choiceLabelCounts[baseLabel] += 1;
                }
                const count = choiceLabelCounts[baseLabel];
                let finalLabel = baseLabel;
                if (count > 0) {
                    finalLabel = baseLabel + ' ' + loopIndex;
                }

                const hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.className = 'js-custom-color-prop';
                hidden.name = `properties[${finalLabel}]`;
                hidden.value = selectedVal;
                productForm.appendChild(hidden);
            });

            // Price options property (single group)
            const priceGroupEl = document.querySelector('[data-price-label][data-price-loop]');
            if (priceGroupEl) {
                const labelRaw = priceGroupEl.getAttribute('data-price-label') || 'Price Option';
                let baseLabel = labelRaw.trim().replace(/:\s*$/, '');
                if (baseLabel === '') baseLabel = 'Price Option';
                baseLabel = titleCase(baseLabel);
                const checked = priceGroupEl.querySelector('input[type="radio"]:checked');
                if (checked) {
                    const hidden = document.createElement('input');
                    hidden.type = 'hidden';
                    hidden.className = 'js-custom-color-prop';
                    hidden.name = `properties[${baseLabel}]`;
                    hidden.value = checked.value;
                    productForm.appendChild(hidden);
                }
            }
        }, { capture: true });
    }
});

// Set up form validation immediately (not waiting for DOMContentLoaded)
function setupFormValidation() {
    console.log('Setting up form validation...');

    // Function to perform validation
    function validateForm() {
        console.log('validateForm called');
        debugger; // Moved debugger here so it's always hit during validation
        let hasErrors = false;
        console.log("s 7");


        // Clear existing error messages
        document.querySelectorAll('.custom-dropdown-error, .field-error').forEach(error => {
            error.remove();
        });

        // No border styling reset needed since we're not adding borders

        // Check custom dropdowns
        document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
            if (dropdown.closest('.sticky-cart')) return;

            const wrapper = dropdown.parentNode;
            const originalSelect = wrapper.querySelector('.select__select');

            if (originalSelect && (originalSelect.selectedIndex === -1 || originalSelect.value === '')) {
                hasErrors = true;
                console.log('Custom dropdown validation failed:', originalSelect);

                const errorMsg = document.createElement('div');
                errorMsg.className = 'custom-dropdown-error';
                errorMsg.textContent = 'זהו שדה חובה למילוי';
                errorMsg.style.fontSize = '14px';
                errorMsg.style.color = 'rgb(237, 107, 142)';
                errorMsg.style.lineHeight = '1.4';
                errorMsg.style.marginTop = '4px';

                // Add error message after the entire dropdown
                dropdown.parentNode.appendChild(errorMsg);
            }
        });

        // Check ALL select elements
        document.querySelectorAll('select').forEach(select => {
            if (select.closest('.sticky-cart') || select.closest('.select').style.display === 'none') return;

            if (select.selectedIndex === -1 || select.value === '') {
                hasErrors = true;
                console.log('Regular select validation failed:', select);

                const errorMsg = document.createElement('div');
                errorMsg.className = 'field-error';
                errorMsg.textContent = 'יש לבחור אפשרות';
                errorMsg.style.fontSize = '14px';
                errorMsg.style.color = 'rgb(237, 107, 142)';
                errorMsg.style.lineHeight = '1.4';
                errorMsg.style.marginTop = '4px';

                const wrapper = select.closest('.product-form__input');
                if (wrapper) {
                    wrapper.appendChild(errorMsg);
                }
            }
        });

        // Check color groups
        document.querySelectorAll('[data-color-label][data-color-loop]').forEach(colorGroup => {
            const inputs = colorGroup.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            const checkedInputs = colorGroup.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');

            if (inputs.length > 0 && checkedInputs.length === 0) {
                hasErrors = true;
                console.log('Color group validation failed:', colorGroup);

                const errorMsg = document.createElement('div');
                errorMsg.className = 'field-error';
                errorMsg.textContent = 'יש לבחור אפשרות';
                errorMsg.style.fontSize = '14px';
                errorMsg.style.color = 'rgb(237, 107, 142)';
                errorMsg.style.lineHeight = '1.4';
                errorMsg.style.marginTop = '4px';

                // Add error message after the color group
                colorGroup.appendChild(errorMsg);
            }
        });

        // Check choice groups  
        document.querySelectorAll('[data-choice-label][data-choice-loop]').forEach(choiceGroup => {
            const inputs = choiceGroup.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            const checkedInputs = choiceGroup.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');

            if (inputs.length > 0 && checkedInputs.length === 0) {
                hasErrors = true;
                console.log('Choice group validation failed:', choiceGroup);

                const errorMsg = document.createElement('div');
                errorMsg.className = 'field-error';
                errorMsg.textContent = 'יש לבחור אפשרות';
                errorMsg.style.fontSize = '14px';
                errorMsg.style.color = 'rgb(237, 107, 142)';
                errorMsg.style.lineHeight = '1.4';
                errorMsg.style.marginTop = '4px';

                // Add error message after the choice group
                choiceGroup.appendChild(errorMsg);
            }
        });

        // Check price options
        document.querySelectorAll('[data-price-label][data-price-loop]').forEach(priceGroup => {
            const inputs = priceGroup.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            const checkedInputs = priceGroup.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');

            if (inputs.length > 0 && checkedInputs.length === 0) {
                hasErrors = true;
                console.log('Price group validation failed:', priceGroup);

                const errorMsg = document.createElement('div');
                errorMsg.className = 'field-error';
                errorMsg.textContent = 'יש לבחור אפשרות מחיר';
                errorMsg.style.fontSize = '14px';
                errorMsg.style.color = 'rgb(237, 107, 142)';
                errorMsg.style.lineHeight = '1.4';
                errorMsg.style.marginTop = '4px';

                // Add error message after the price group
                priceGroup.appendChild(errorMsg);
            }
        });

        // Check ALL other fieldsets
        document.querySelectorAll('fieldset').forEach(fieldset => {
            if (fieldset.closest('.sticky-cart') ||
                fieldset.hasAttribute('data-color-loop') ||
                fieldset.hasAttribute('data-choice-loop') ||
                fieldset.hasAttribute('data-price-loop')) {
                return;
            }

            const inputs = fieldset.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            const checkedInputs = fieldset.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');

            if (inputs.length > 0 && checkedInputs.length === 0) {
                hasErrors = true;
                console.log('Native fieldset validation failed:', fieldset);

                const errorMsg = document.createElement('div');
                errorMsg.className = 'field-error';
                errorMsg.textContent = 'יש לבחור אפשרות';
                errorMsg.style.fontSize = '14px';
                errorMsg.style.color = 'rgb(237, 107, 142)';
                errorMsg.style.lineHeight = '1.4';
                errorMsg.style.marginTop = '4px';

                // Add error message after the fieldset
                fieldset.appendChild(errorMsg);
            }
        });

        console.log('Total validation errors found:', hasErrors);

        if (hasErrors) {
            const firstError = document.querySelector('.custom-dropdown-error, .field-error');
            if (firstError) {
                firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            alert('יש למלא את כל השדות הנדרשים');
            return false;
        }

        return true;
    }

    // Find the form
    const wdFormIdDiv = document.getElementById('wd-form-id-info');
    const productFormId = wdFormIdDiv ? wdFormIdDiv.getAttribute('data-form-id') : null;

    const productForm = document.getElementById(productFormId);
    console.log('Product form found:', productForm);

    if (productForm) {
        console.log('Adding form validation event listeners...');

        // Multiple event listeners to catch all submission methods
        productForm.addEventListener('submit', function (e) {
            console.log('Form submit event triggered (capture phase)');
            if (!validateForm()) {
                console.log('Validation failed - preventing submit');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            }
            console.log('Validation passed - allowing submit');
        }, { capture: true, passive: false });

        // Intercept fetch/AJAX requests
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            const url = args[0];
            if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('cart/add.js'))) {
                console.log('Fetch cart/add intercepted');
                if (!validateForm()) {
                    return Promise.reject(new Error('Validation failed'));
                }
            }
            return originalFetch.apply(this, args);
        };

        // Intercept XMLHttpRequest
        const originalOpen = XMLHttpRequest.prototype.open;
        const originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url, ...args) {
            this._url = url;
            return originalOpen.apply(this, [method, url, ...args]);
        };

        XMLHttpRequest.prototype.send = function (...args) {
            if (this._url && (this._url.includes('/cart/add') || this._url.includes('cart/add.js'))) {
                console.log('XMLHttpRequest cart/add intercepted');
                if (!validateForm()) {
                    return;
                }
            }
            return originalSend.apply(this, args);
        };

        // Also intercept add to cart buttons directly
        document.addEventListener('click', function (e) {
            const button = e.target.closest('button[name="add"], button[type="submit"], .btn-product-form, .product-form__cart-button');
            if (button && productForm.contains(button)) {
                console.log('Add to cart button clicked');
                if (!validateForm()) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                }
            }
        }, true);

        console.log('Form validation setup complete for form:', productForm.id);
    } else {
        console.log('Product form not found - will retry in 100ms');
        setTimeout(setupFormValidation, 100);
    }
}

// Run setup immediately if DOM is ready, otherwise wait
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupFormValidation);
} else {
    setupFormValidation();
}